import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { apiKeys as apiKeysApi } from 'redux/modules/api'

function decorator() {
  return ComposedComponent => {
    const enhance = compose(
      connect(
        ({ api, app }) => ({
          localeId: app.locale.id,
          apiKeys: api.apiKeys
        }),
        { ...apiKeysApi }
      )
    )

    class ApiKeys extends Component {
      static propTypes = {
        getOrganizationApiKeys: PropTypes.func.isRequired,
        deleteApiKey: PropTypes.func.isRequired,
        addApiKey: PropTypes.func.isRequired,
      }

      render() {
        return (
          <ComposedComponent
            key={this.key}
            {...this.props}
          />
        )
      }
    }
    return enhance(ApiKeys)
  }
}

export default decorator
